module.exports = __webpack_public_path__ + "resources\\localization\\es-es.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/resources/localization/es-es.json
 ** module id = 30
 ** module chunks = 0
 **/